import {useTranslation} from "react-i18next";
import {Descriptions, Tabs, Typography} from "antd";
import ReactJson from "react-json-view";
import response_payments_get from "../get/response_payments_get.json"
import React from "react";
import {GetApiCollapsePanel} from "../../../get_api_collapse_panel";

export const ApiPaymentsGet = () => {
    const {t} = useTranslation()

    return (
        <GetApiCollapsePanel name={'payments'} descriptions={t('get_payments')}>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab={t('parameters')} key="1">
                    {t('request_filter')}
                    <br/>
                    <br/>
                    <Descriptions bordered size={'small'}>
                        <Descriptions.Item label={
                            <>
                                <span style={{fontWeight:'bold', fontSize:'medium'}}>
                                    date
                                </span>
                                <br/>
                                <span style={{fontSize:'small', color:'gray'}}>
                                    string
                                </span>
                            </>
                        }
                                           span={3}
                                           style={{whiteSpace:'pre-line'}}>
                            {t('request_date_format_order')}
                        </Descriptions.Item>
                    </Descriptions>
                    <br/><br/>
                    <Typography.Title level={5}>{t('example')}</Typography.Title>

                    <span>https://choven.lukas.ua/api/v1/payments?date=2023-08-07</span>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t('response')} key="2">
                    <Descriptions bordered size={'small'}>
                        <Descriptions.Item label={
                            <span style={{fontWeight:'bold'}}>{t('code')}</span>}
                                           span={3}>{<span style={{fontWeight:'bold'}}>{t('descriptions')}</span>}</Descriptions.Item>
                        <Descriptions.Item label={200}
                                           span={3}>{t('ok')}</Descriptions.Item>
                        <Descriptions.Item label={403}
                                           span={3}>{t('authorisation_error')}</Descriptions.Item>
                    </Descriptions>
                    <br/>
                    <br/>
                    <Typography.Title level={5}>{t('example')}</Typography.Title>
                    <ReactJson
                        src={response_payments_get}
                        name={null}
                        displayObjectSize={false}
                        displayArrayKey={false}
                        displayDataTypes={false}
                        enableClipboard={false}
                               style={{fontSize: '10pt'}}/>


                </Tabs.TabPane>
            </Tabs>
        </GetApiCollapsePanel>
    )
}